import { render, staticRenderFns } from "./PartnerDetails.vue?vue&type=template&id=dfedadaa&scoped=true"
import script from "./PartnerDetails.vue?vue&type=script&lang=js"
export * from "./PartnerDetails.vue?vue&type=script&lang=js"
import style0 from "./PartnerDetails.vue?vue&type=style&index=0&id=dfedadaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfedadaa",
  null
  
)

export default component.exports